const locale = {
  TITLE: "Ülke",
};

export default locale;
